/* eslint-disable no-useless-escape, max-len */
const supportedEmbeds = {
  youtube: {
    // https://regex101.com/r/ssFKIf/1
    regex:
      /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:youtube\.com|youtu.be))(\/(?:[\w\-]+\?v=|embed\/|v\/)?)([\w\-]+)(\S+)?$/i,
    baseUrl: 'https://www.youtube.com/embed/$5',
    urlParams: {
      // DOCS: https://developers.google.com/youtube/player_parameters
      autoplay: 1,
      loop: 0,
      controls: 0,
      enablejsapi: 1,
      playsinline: 1,
      modestbranding: 1,
      showinfo: 0,
      rel: 0,
    },
  },
  facebook: {
    // DOCS: https://developers.facebook.com/docs/plugins/embedded-video-player/#how-to-get-a-video-posts-url
    // https://regex101.com/r/wIHaK2/1

    // TODO: Facebook video URLs can come in more than one valid format. Currently this Regex only works for two of them.
    // We control that URL currently, so no big deal for now. However if we use this to embed from a user provided URL
    // we need to tweak the Regex to work for any valid video URL.
    regex:
      /^((?:https?:)?\/\/)?((?:www|m)\.)?((?:facebook\.com|facebook.co))(\/(?:[\w\-]+\?v=|facebook\/videos\/|v\/)?)([\w\-]+)(\S+)?$/i,
    baseUrl: 'https://www.facebook.com/facebook/videos/$5',
  },

  // not required for graphic support currently, but leaving the code here for easily turning on support later.
  // vimeo: {
  //   regex: /^.*vimeo.com\/(\d+)($|\/|\b)/i,
  //   baseUrl: "https://player.vimeo.com/video/$1",
  //   urlParams: {
  //     title: 0,
  //     byline: 0,
  //     portrait: 0,
  //   },
  // },
  // dailymotion: {
  //   regex: /^.*(?:\/video|dai.ly)\/([A-Za-z0-9]+)([^#\&\?]*).*/i,
  //   baseUrl: "https://www.dailymotion.com/embed/video/$1",
  //   urlParams: {
  //     autoplay: 0,
  //   },
  // },
  // coub: {
  //   regex: /^.*coub.com\/(?:embed|view)\/([A-Za-z0-9]+)([^#\&\?]*).*/i,
  //   baseUrl: "https://coub.com/embed/$1",
  //   urlParams: {
  //     autoplay: 0,
  //   },
  // },
};

export default supportedEmbeds;
